module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10218.28a35d6f.jpg";